import { TextareaField } from '#app/components/form/textarea-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly value: string
	readonly errors: readonly string[]
	readonly onChange: (value: string) => void
}

export function AllergenManagementSection({
	resources,
	value,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Allergen management"
			description="Show how you keep fragrance allergens and restricted ingredients in check for every SKU."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<TextareaField
				labelProps={{
					children:
						'How do you track fragrance allergens and other restricted ingredients?',
				}}
				textareaProps={{
					name: 'allergenTracking',
					value,
					onChange: (event) => onChange(event.target.value),
					rows: 4,
				}}
				descriptionProps={{
					children:
						'Mention tools or spreadsheets, who maintains them, and how updates make their way onto artwork.',
				}}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
